import { render, staticRenderFns } from "./OnboardingFormDetails.vue?vue&type=template&id=71b2e5f5&"
import script from "./OnboardingFormDetails.vue?vue&type=script&lang=js&"
export * from "./OnboardingFormDetails.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingFormDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports